import styled from '@emotion/styled';
import { typography } from 'src/theme/typography';

const ModalConfirmVersionStyle = styled('div')`
    .contentModal {
        ${typography.bodyMd}
        color: var(--sand-700);
    }
    .quoteTitle {
        color: var(--blue-400);
    }
    .text-require{
        color: #CC3027;
    }

    .groupBtn {
        width: 100%;
        display: flex;
        justify-content: flex-end;
        gap: 16px;
        margin-top: 24px;
    }
    .btnEdit,
    .btnSend {
        ${typography.buttonMd}
        height: 40px;
        padding: 8px 16px;
        border-radius: 6px;
        box-shadow: none;
    }
    .btnEdit.ant-btn {
        background: transparent;
        border: 1px solid var(--sand-700);
        color: var(--sand-700);

        &:not(:disabled):hover {
            background: var(--sand-200);
            border-color: var(--sand-700);
            color: var(--sand-700);
        }
    }
    .btnSend.ant-btn {
        background: var(--orange-300);
        border: 1px solid var(--orange-300);
        color: var(--sand-100);

        &:not(:disabled):hover {
            background: var(--orange-400);
            border-color: var(--orange-400);
            color: var(--sand-100);
        }
    }
    .groupInput {
        ${typography.bodyMd}
        color: var(--sand-700);
        margin-top: 24px;

        > div:first-of-type {
            margin-bottom: 8px;
            color: var(--grey);
        }
    }
    .inputNew {
        ${typography.bodyMd}
        font-weight: 400;
        height: 47px;
        padding: 14px 16px;
        border-radius: 3px;
        border: 1px solid var(--sand-400);
        background: var(--white);
        color: var(--sand-700);

        &::placeholder {
            color: var(--sand-400);
        }
    }
`;

export default ModalConfirmVersionStyle;
